import React from 'react'
import {
   ContainerFluid,ContainerFluidX,Container,HeadingText,Cardde,DescText
} from './SectionDComponent.style';
function SectionDComponent() {
  return (
    <div>
        <ContainerFluidX></ContainerFluidX>
        <ContainerFluid>
            <Container>
                <div className='row'>
                    <div className='col s12 center'>
                        <HeadingText>Why Choose Yalla</HeadingText>
                    </div>
                </div>
                <Container>
                    <div className='row '>
                        <div className='col s12 m12 l4 mt-50'>
                            <Cardde>
                                <div className='center imag'>
                                    <img className='mt-50' src="https://res.cloudinary.com/yalla-ng/image/upload/v1657447237/re-brand/Frame_2_l8jf1f.svg" alt=""/>
                                </div>
                                <div className='center descc'>
                                <DescText>
                                        Shariah-Compliant 
                                </DescText>
                                </div>
                            </Cardde>
                        </div>
                        <div className='col s12 m12 l4 mt-50'>
                            <Cardde>
                                <div className='center imag'>
                                    <img className='mt-50' src="https://res.cloudinary.com/yalla-ng/image/upload/v1657447647/re-brand/Group_766_nxa46i.svg" alt=""/>
                                </div>
                                <div className='center descc'>
                                <DescText>
                                Halal Savings
                                </DescText>
                                </div>
                            </Cardde>
                        </div>
                        <div className='col s12 m12 l4 mt-50'>
                            <Cardde>
                                <div className='center imag'>
                                    <img className='mt-50' src="https://res.cloudinary.com/yalla-ng/image/upload/v1657447689/re-brand/Frame_3_uizsk3.svg" alt=""/>
                                </div>
                                <div className='center descc'>
                                    <DescText style={{
                                        marginTop:"40px"
                                    }}>
                                        Share Profit
                                    </DescText>
                                </div>
                            </Cardde>
                        </div>
                    </div>
                </Container>

            </Container>
        </ContainerFluid>
    </div>
  )
}

export default SectionDComponent